<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="10px" class="end-connection" fxFlex *ngIf="type!=='absolute'">

    <div fxLayoutAlign="center center" *ngIf="innerHeigth > 350">
        <i class="material-icons primary-ico" [ngStyle]="{'font-size': '8em'}" [ngStyle.xs]="{'font-size': '5em'}">
      account_circle
    </i>
    </div>

    <div fxLayoutAlign="center center" class="text-center">
        <span class="mat-title">{{"endorder.notlogged" |
      translate}}</span>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <button mat-raised-button color="accent" (click)="authPageServ.goLogin(redirectPage)" angulartics2On="click" angularticsAction="redirectLogin" angularticsCategory="order" angularticsLabel="need-connection">{{"main.word.login" | translate}}</button>
        <button mat-raised-button color="primary" (click)="authPageServ.goRegister(redirectPage)" angulartics2On="click" angularticsAction="redirectRegister" angularticsCategory="order" angularticsLabel="need-connection">{{"main.word.register" | translate}}</button>
    </div>

</div>


<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayoutGap.xs="10px" class="full-screen type-absolute rad-bord" *ngIf="type ==='absolute'">

    <div fxLayoutAlign="center center" *ngIf="innerHeigth > 350">
        <i class="material-icons primary-ico" [ngStyle]="{'font-size': '8em'}" [ngStyle.xs]="{'font-size': '5em'}">
  account_circle
    </i>
    </div>

    <div fxLayoutAlign="center center" class="text-center">
        <span class="mat-title">{{"endorder.notlogged" |
  translate}}</span>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <button mat-stroked-button color="accent" (click)="authPageServ.goLogin(redirectPage)" angulartics2On="click" angularticsAction="redirectLogin" angularticsCategory="order" angularticsLabel="need-connection">{{"main.word.login" | translate}}</button>
        <button mat-stroked-button color="primary" (click)="authPageServ.goRegister(redirectPage)" angulartics2On="click" angularticsAction="redirectRegister" angularticsCategory="order" angularticsLabel="need-connection">{{"main.word.register" | translate}}</button>
    </div>

    <button mat-stroked-button (click)="close()">{{"dialogs.go-back" | translate}}</button>

</div>